/* eslint-disable import/no-anonymous-default-export */
/**
 * 언론 배포 신청 캠페인 설정
 */
import RefundBadge from "../components/RefundBadge";
export default {
  id: "newsRelease",
  title: "언론 배포 신청",

  api: {
    list: {
      method: "GET",
      url: "/advertisement/admin/newsReleases",
    },
    count: {
      method: "GET",
      url: "/advertisement/admin/newsReleases/count",
    },
    submitted: {
      method: "POST",
      url: "/advertisement/admin/newsReleases/submitted",
    },
    paid: {
      method: "POST",
      url: "/advertisement/admin/newsReleases/paid",
    },
    complete: {
      method: "POST",
      url: "/advertisement/admin/newsReleases/completed",
    },
    refund: {
      method: "POST",
      url: "/advertisement/admin/campaigns/refund",
      version: 2,
    },
    delete: {
      method: "DELETE",
      url: "/advertisement/admin/campaigns",
    },
    extra: {
      categories: {
        method: "GET",
        url: "/advertisement/admin/newsRelease/categories",
      },
      mediaNames: {
        method: "GET",
        url: "/advertisement/admin/products",
        params: { type: "news_release" },
      },
    },
  },

  filters: {
    default: {
      keyword: "",
      categoryId: "",
      adProductId: "",
      isGhostwriting: "",
      submitted: "전체",
      paid: "전체",
      status: "전체",
      submitDate: "",
      completionDate: "",
      page: 1,
      limit: 50,
    },
    schema: [
      {
        name: "keyword",
        label: "검색",
        type: "text",
        placeholder: "신청자, 업체명",
      },
      {
        name: "categoryId",
        label: "카테고리",
        type: "select",
        options: [], // 동적으로 로드
      },
      {
        name: "adProductId",
        label: "언론사",
        type: "select",
        options: [], // 동적으로 로드
      },
      {
        name: "isGhostwriting",
        label: "대필여부",
        type: "select",
        options: [
          { value: "", label: "전체" },
          { value: 1, label: "가능" },
          { value: 0, label: "불가능" },
        ],
      },
      {
        name: "submitted",
        label: "접수여부",
        type: "select",
        options: [
          { value: "전체", label: "전체" },
          { value: "complete", label: "접수완료" },
          { value: "notComplete", label: "미접수" },
        ],
      },
      {
        name: "paid",
        label: "결제상태",
        type: "select",
        options: [
          { value: "전체", label: "전체" },
          { value: "complete", label: "결제완료" },
          { value: "notComplete", label: "미결제" },
          { value: "refund", label: "환불" },
        ],
      },
      {
        name: "status",
        label: "상태",
        type: "select",
        options: [
          { value: "전체", label: "전체" },
          { value: "waiting", label: "대기중" },
          { value: "processing", label: "처리중" },
          { value: "completed", label: "완료" },
        ],
      },
      {
        name: "submitDate",
        label: "접수일",
        type: "date",
      },
      {
        name: "completionDate",
        label: "완료일",
        type: "date",
      },
    ],
  },

  summary: {
    fields: [
      { key: "totalCount", label: "총 신청" },
      { key: "waitingCount", label: "대기중" },
      { key: "processingCount", label: "처리중" },
      { key: "completedCount", label: "완료" },
    ],
  },

  table: {
    keyField: "adNewsReleaseId",
    rowClick: {
      enabled: true,
      handler: (row) => {
        // 행 클릭 시 상세 정보 표시 (페이지 컴포넌트에서 처리)
      },
    },
    columns: [
      {
        key: "adCampaignMetaId",
        label: "아이디",
        center: true,
      },
      {
        key: "createdAt",
        label: "캐랭접수시간",
        center: true,
        render: (row) => {
          if (!row.createdAt) return "";
          const [date, time] = row.createdAt.split(" ");
          return (
            <>
              <div>{date}</div>
              <div>{time?.slice(0, 8)}</div>
            </>
          );
        },
      },
      {
        key: "userName",
        label: "접수자(ID)/접수일/상태",
        center: true,
        render: (row) => (
          <>
            <div>
              <span className="user-name">
                {row.userName}
                {row.userId ? ` (${row.userId})` : ""}
              </span>
            </div>
            <div>{row.submitDate || "-"}</div>
            <div>
              <span className={`badge badge-${row.status}`}>{row.status}</span>
            </div>
          </>
        ),
      },
      {
        key: "mediaName",
        label: "언론사명/카테고리/대필여부",
        center: true,
        render: (row) => (
          <>
            <div>{row.mediaName || "-"}</div>
            <div>{row.categoryName || "-"}</div>
            <div>
              <span className={`badge badge-${row.isGhostwriting ? "가능" : "불가능"}`}>
                {row.isGhostwriting ? "가능" : "불가능"}
              </span>
            </div>
          </>
        ),
      },
      {
        key: "articleCount",
        label: "발행기사수/가격/레퍼런스URL",
        center: true,
        render: (row) => {
          const truncateText = (text, maxLength = 30) => {
            if (!text) return "-";
            return text.length > maxLength ? text.substring(0, maxLength) + "..." : text;
          };

          return (
            <>
              <div>{row.articleCount}건</div>
              <div>{row.totalCost?.toLocaleString()}원</div>
              <div>
                {row.referenceUrl ? (
                  <a
                    href={row.referenceUrl}
                    target="_blank"
                    rel="noopener noreferrer"
                    onClick={(e) => e.stopPropagation()}
                  >
                    {truncateText(row.referenceUrl)}
                  </a>
                ) : (
                  "-"
                )}
              </div>
            </>
          );
        },
      },
      {
        key: "companyName",
        label: "업체명/업체URL",
        center: true,
        render: (row) => (
          <>
            <div>{row.companyName || "-"}</div>
            <div>
              {row.companyUrl ? (
                <a href={row.companyUrl} target="_blank" rel="noopener noreferrer" onClick={(e) => e.stopPropagation()}>
                  {row.companyUrl}
                </a>
              ) : (
                "-"
              )}
            </div>
          </>
        ),
      },
      {
        key: "isPaid",
        label: "결제상태  ",
        center: true,
        render: (row) => (
          <>
            <div>
              {row.isPaid === 2 ? (
                <RefundBadge
                  refundedAmount={row.refundedAmount ?? 0}
                  remainingAmount={row.remainingAmount ?? 0}
                  refundDate={row.refundDate}
                />
              ) : (
                <span className={`badge badge-${row.isPaid === 1 ? "결제완료" : "미결제"}`}>
                  {row.isPaid === 1 ? "결제완료" : "미결제"}
                </span>
              )}
            </div>
          </>
        ),
      },
      {
        key: "report",
        label: "리포트",
        center: true,
        render: (row) => (
          <button
            type="button"
            className="status-btn submitted"
            data-campaign-meta-id={row.adCampaignMetaId}
            data-place-name={row.companyName || ""}
            onClick={(e) => {
              e.stopPropagation();
            }}
          >
            리포트
          </button>
        ),
      },
      {
        key: "notification",
        label: "알림톡",
        center: true,
        render: (row) => {
          const productName = "언론 배포";

          return (
            <button
              type="button"
              className="notification-btn"
              data-campaign-meta-id={row.adCampaignMetaId}
              data-action="notification"
              data-user-id={row.userId}
              data-product-name={productName}
              data-submitted-at={row.createdAt || ""}
              data-purchase-amount={row.totalCost ?? ""}
              onClick={(e) => e.stopPropagation()}
            >
              알림톡
            </button>
          );
        },
      },
      {
        key: "memo",
        label: "메모",
        center: true,
        render: (row) => (
          <button
            type="button"
            className={row.memo ? "memo-btn has-memo" : "memo-btn"}
            data-action="memo"
            data-campaign-meta-id={row.adCampaignMetaId}
            data-memo={row.memo || ""}
            onClick={(e) => e.stopPropagation()}
          >
            {row.memo
              ? <span className="memo-preview">{row.memo}</span>
              : "메모"}
          </button>
        ),
      },
    ],
  },

  actions: [
    {
      id: "submitted",
      label: "접수/취소",
      actionType: "submitted",
      enabledWhen: (selectedIds) => selectedIds.length > 0,
      payloadBuilder: (selectedIds) => ({
        adNewsReleaseIds: selectedIds,
      }),
    },
    {
      id: "paid",
      label: "결제완료",
      actionType: "paid",
      enabledWhen: (selectedIds, items) => {
        if (selectedIds.length === 0) return false;
        const alreadyPaid = items.some(
          (item) => selectedIds.includes(item.adNewsReleaseId) && (item.isPaid === true || item.isPaid === 1),
        );
        return !alreadyPaid;
      },
      payloadBuilder: (selectedIds) => ({
        adNewsReleaseIds: selectedIds,
      }),
    },
    {
      id: "complete",
      label: "처리완료/취소",
      actionType: "complete",
      enabledWhen: (selectedIds) => selectedIds.length > 0,
      payloadBuilder: (selectedIds) => ({
        adNewsReleaseIds: selectedIds,
      }),
    },
    {
      id: "refund",
      label: "환불",
      actionType: "refund",
      requires: "ad.campaign.refund", // 권한 없으면 버튼 숨김 (R-FE-04)
      enabledWhen: (selectedIds, items) => {
        if (selectedIds.length === 0) return false;
        return items.some(
          (item) => selectedIds.includes(item.adNewsReleaseId) && (item.isPaid === 1 || item.isPaid === 2) && (item.remainingAmount ?? item.totalAmount ?? 0) > 0
        );
      },
    },
    {
      id: "delete",
      label: "삭제",
      actionType: "delete",
      enabledWhen: (selectedIds, items) => {
        if (selectedIds.length === 0) return false;
        const selectedCampaigns = items.filter((campaign) => selectedIds.includes(campaign.adCampaignMetaId));
        const hasInvalidCampaign = selectedCampaigns.some((campaign) => {
          const userName = campaign.userName || "";
          return (
            !userName.includes("테스트") &&
            !userName.includes("전유상") &&
            !userName.includes("이령빈") &&
            !userName.includes("서한석") &&
            !userName.includes("null") &&
            !userName.includes("채영호") &&
            !userName.includes("매니저")
          );
        });
        const hasNotTerminatedCampaign = selectedCampaigns.some(
          (campaign) => !(campaign.status === "종료" && campaign.paid === "notComplete"),
        );
        return !(hasInvalidCampaign && hasNotTerminatedCampaign);
      },
      confirm: "선택한 언론 배포 신청을 삭제하시겠습니까?",
      payloadBuilder: (selectedIds, items) => {
        const selectedCampaigns = items.filter((item) => selectedIds.includes(item.adNewsReleaseId));
        const campaigns = selectedCampaigns.map((newsRelease) => ({
          adCampaignMetaId: newsRelease.adCampaignMetaId,
          userName: newsRelease.userName,
        }));
        return {
          campaigns,
        };
      },
    },
  ],

  download: {
    type: "xlsx",
    fileName: "언론배포_신청목록.xlsx",
    sheetName: "언론배포신청목록",
    transformRow: (row) => ({
      신청자: row.userName || "",
      업체명: row.companyName || "",
      업체URL: row.companyUrl || "",
      언론사명: row.mediaName || "",
      카테고리: row.categoryName || "",
      대필여부: row.isGhostwriting ? "가능" : "불가능",
      발행기사수: row.articleCount || 0,
      가격: row.totalCost || 0,
      가이드라인: row.guideline || "",
      발행기사URL: "", // 빈 값으로 설정
    }),
  },
};
